import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {environment} from "./environments/local/environment";
if (!environment.loggingEnabled) { //HINT - enhancement: remove when logging service is fully used
  window.console.log = () => { }
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
